import revive_payload_client_eMDGMnorG2 from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_FRWT9BcRSV from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_cihwayiN4v from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_cB0XK8CI9g from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_OZhf6abliK from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_iivzkT8oHQ from "/app/node_modules/.pnpm/@pinia+nuxt@0.5.1_rollup@4.17.2_vue@3.4.21/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_6SRhLmmLJQ from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import script_z4FA2lekBu from "/app/node_modules/.pnpm/@nuxtjs+turnstile@0.7.1_rollup@4.17.2/node_modules/@nuxtjs/turnstile/dist/runtime/plugins/script.mjs";
import plugin_xuy7MCCzJQ from "/app/node_modules/.pnpm/@nuxtjs+device@3.1.1_rollup@4.17.2/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import i18n_OCdSDZzPCt from "/app/node_modules/.pnpm/@nuxtjs+i18n@8.3.1_rollup@4.17.2_vue@3.4.21/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_koth6n4aZs from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import pusher_T6fDwDIeLY from "/app/plugins/pusher.ts";
import segment_xRnKTSkpmU from "/app/plugins/segment.ts";
import algolia_9jd9dIbZwL from "/app/plugins/algolia.ts";
import clickOutside_ZB3Eg0wOVk from "/app/plugins/clickOutside.ts";
import crisp_client_DCubnCdDP5 from "/app/plugins/crisp.client.ts";
import device_PxhEqcDcOg from "/app/plugins/device.ts";
import error_handler_client_sQhJOBiqXf from "/app/plugins/error-handler.client.ts";
import highChart_client_dGmOCQX4nf from "/app/plugins/highChart.client.ts";
import loadCurrencies_rt6D6XM5xQ from "/app/plugins/loadCurrencies.ts";
import loadGames_Rb0WDNgVi5 from "/app/plugins/loadGames.ts";
import loadUser_LsqsWAQztf from "/app/plugins/loadUser.ts";
import nuxt_gtm_client_cy87T2HFYu from "/app/plugins/nuxt-gtm.client.ts";
import sanitize_nuxt_state_client_eeqrzZwvlO from "/app/plugins/sanitize-nuxt-state.client.ts";
import sentrysetUser_client_xBdIGAc2KX from "/app/plugins/sentrysetUser.client.ts";
import tidio_client_CExgt3bj1j from "/app/plugins/tidio.client.ts";
import utm_tracker_client_iwuLFZ59k8 from "/app/plugins/utm-tracker.client.ts";
import vDragScroll_hc6aCRZx47 from "/app/plugins/vDragScroll.ts";
import wowhead_tooltips_client_dSl65yiXO7 from "/app/plugins/wowhead-tooltips.client.ts";
export default [
  revive_payload_client_eMDGMnorG2,
  unhead_FRWT9BcRSV,
  router_cihwayiN4v,
  payload_client_cB0XK8CI9g,
  check_outdated_build_client_OZhf6abliK,
  plugin_vue3_iivzkT8oHQ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_6SRhLmmLJQ,
  script_z4FA2lekBu,
  plugin_xuy7MCCzJQ,
  i18n_OCdSDZzPCt,
  chunk_reload_client_koth6n4aZs,
  pusher_T6fDwDIeLY,
  segment_xRnKTSkpmU,
  algolia_9jd9dIbZwL,
  clickOutside_ZB3Eg0wOVk,
  crisp_client_DCubnCdDP5,
  device_PxhEqcDcOg,
  error_handler_client_sQhJOBiqXf,
  highChart_client_dGmOCQX4nf,
  loadCurrencies_rt6D6XM5xQ,
  loadGames_Rb0WDNgVi5,
  loadUser_LsqsWAQztf,
  nuxt_gtm_client_cy87T2HFYu,
  sanitize_nuxt_state_client_eeqrzZwvlO,
  sentrysetUser_client_xBdIGAc2KX,
  tidio_client_CExgt3bj1j,
  utm_tracker_client_iwuLFZ59k8,
  vDragScroll_hc6aCRZx47,
  wowhead_tooltips_client_dSl65yiXO7
]